export const PERMISSIONS = {
    // Team Lead
    CALL_SVC_TEAM_LEAD_BASE: "CALL_TL1",

    // Admin
    CALL_SVC_ADMIN_BASE: "CALL_AD1",
    CALL_CALL_DETAIL_ACTIONS: "CALL_AD2",

    // Calls
    /** Frontend-first until backend ships. Sidebar: Calls. Dashboard: Last calls widget. */
    CALL_READ_CALLS: "CALL_RC1",
    /** Frontend-first until backend ships. Calls page: team member selector. */
    CALL_CALLS_SELECT_MEMBER: "CALL_RC2",
    /** Frontend-first until backend ships. Calls page: All agents (global) view. */
    CALL_CALLS_GLOBAL_SEARCH: "CALL_CG1",
    /** Frontend-first until backend ships. Call details: Evaluation tab. */
    CALL_CALL_EVALUATION: "CALL_EV1",

    // Dialer
    /** Frontend-first until backend ships. Right sidebar / mobile dialer. */
    CALL_DIALER: "CALL_DI1",

    // Setting lists
    /** Frontend-first until backend ships. Sidebar: Lists. */
    CALL_SETTING_LISTS: "CALL_SL1",

    // Scripts
    /** Frontend-first until backend ships. Sidebar: Scripts. */
    CALL_SCRIPTS_READ: "CALL_SC1",

    // KPIs
    /** Frontend-first until backend ships. Sidebar: Performance → KPIs. Dashboard: Today's performance widget. */
    CALL_KPIS_READ: "CALL_KP1",
    /** Frontend-first until backend ships. KPIs page: team member selector. */
    CALL_KPIS_SELECT_MEMBER: "CALL_KP2",

    // Appointments
    /** Frontend-first until backend ships. Appointments page: team member selector. */
    CALL_APPOINTMENTS_SELECT_MEMBER: "CALL_AP1",

    // Calendar capacities
    /** Frontend-first until backend ships. Sidebar: Calendar Capacities. Dashboard: Calendar capacities widget. */
    CALL_CALENDAR_CAPACITIES: "CALL_CC1",

    // Calendar (legacy)
    CALL_CALENDAR_CREATE: "CALL_CA1",
    CALL_CALENDAR_UPDATE: "CALL_CA2",
    CALL_CALENDAR_DELETE: "CALL_CA3",
    CALL_CALENDAR_READ: "CALL_CA4", // Dashboard: Upcoming appointments widget. Sidebar: Appointments.

    // Calendar bookings
    CALL_CALENDAR_BOOKING_READ: "CALL_CB1",
    CALL_CALENDAR_BOOKING_READ_ME: "CALL_CB2",
    CALL_CALENDAR_BOOKING_MANAGE: "CALL_CB3",

    CALL_CALENDAR_PLAN_CREATE: "CALL_CP1",
    CALL_CALENDAR_PLAN_READ: "CALL_CP2",
    CALL_CALENDAR_PLAN_DELETE: "CALL_CP3",
    CALL_CALENDAR_PLAN_UPDATE: "CALL_CP4",

    // Event types
    CALL_EVENT_TYPE_READ: "CALL_ET1",
    CALL_EVENT_TYPE_CREATE: "CALL_ET2",
    CALL_EVENT_TYPE_UPDATE: "CALL_ET3",
    CALL_EVENT_TYPE_DELETE: "CALL_ET4",

    // Setting
    CALL_SETTING_PRIORITY_COUNTS: "CALL_SP1", // GET /setting/priority-counts — Dashboard: Priority Report widget
    CALL_SETTING_DELETE_LEAD: "CALL_SP2", // DELETE /lead/:brandName for stale local leads

    // Agent performance dashboard
    CALL_DASHBOARD_AGENT_PERFORMANCE: "CALL_DP1",

    // Incidents
    /** Notes API + sidebar Incidents + dashboard Pending incidents widget */
    INCIDENT_REPORT_NOTES: "CALL_IN1",

    // Performance reports
    CALL_REPORTS_PRP_ADMIN: "CALL_RP1",
    CALL_REPORTS_SALES_ADMIN: "CALL_RS1",

    /** Frontend-first until backend ships. Sidebar: Performance → Reachability analysis. */
    CALL_REACHABILITY_ANALYSIS: "CALL_RA1",

    // Data export - weekly call/transcript extracts
    CALL_DATA_EXPORT_DOWNLOAD: "CALL_DE1",

    // Hotel
    CALL_HOTEL_BASE: "CALL_HO1",
};
